import * as Styles from './CalendarDatePicker.styles';

export default Styles.DatePicker;
